// extracted by mini-css-extract-plugin
export default {"ModalContent":"ZQmtFzaQ6pYftBwsvPQH","CloseButton":"tDIs2_eyOx7ZNumuyOEi","Title":"QpUwFYwYUmIqffKkjalH","Variant--modern":"tfT4Dh9X8iBeOSeVyJA3"};